export class UpdateAccessGrantRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "subjects",
            "baseName": "subjects",
            "type": "DataCatalogSubjectSet",
            "format": ""
        },
        {
            "name": "privileges",
            "baseName": "privileges",
            "type": "Array<DataCatalogPrivilege>",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "DataCatalogGrantScope",
            "format": ""
        },
        {
            "name": "validFrom",
            "baseName": "validFrom",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAccessGrantRequest.attributeTypeMap;
    }
    constructor() {
    }
}
